"use strict";
/**
 * Reverse API Mappers
 *
 * Converts React models back to the API's nested wrapper format.
 * The backend expects: { degreePlan: {...}, degreePlanTermDtos: [{degreePlanTerm: {...}, degreePlanTermCourseDtos: [...]}] }
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSnapPayload = exports.reverseMapDegreePlan = exports.reverseMapDegreePlanTerm = exports.reverseMapDegreePlanTermCourse = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const reverseMapDegreePlanTermCourse = (c) => ({
    degreePlanTermCourse: {
        courseId: c.course.id,
        failed: c.failed,
    },
});
exports.reverseMapDegreePlanTermCourse = reverseMapDegreePlanTermCourse;
const reverseMapDegreePlanTerm = (t) => ({
    degreePlanTerm: {
        degreePlanTermId: t.id,
        termId: t.term.id,
        position: t.position,
    },
    degreePlanTermCourseDtos: t.courses.map(exports.reverseMapDegreePlanTermCourse),
});
exports.reverseMapDegreePlanTerm = reverseMapDegreePlanTerm;
const reverseMapDegreePlan = (plan) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        degreePlan: {
            degreePlanId: plan.id,
            type: plan.type,
            tenantId: plan.tenantId,
            cohortId: (_a = plan.cohort) === null || _a === void 0 ? void 0 : _a.id,
            organizationId: (_b = plan.organization) === null || _b === void 0 ? void 0 : _b.id,
            academicProgramId: (_c = plan.academicProgram) === null || _c === void 0 ? void 0 : _c.id,
            profileId: (_d = plan.profile) === null || _d === void 0 ? void 0 : _d.id,
            studentProgramId: plan.studentProgramId,
            offSequence: plan.offSequence,
            graduationDate: plan.graduationDate,
            finalActiveTermId: plan.finalActiveTermId,
            parentDegreePlanId: (_e = plan.parentDegreePlan) === null || _e === void 0 ? void 0 : _e.id,
        },
        degreePlanTermDtos: (_f = plan.terms) === null || _f === void 0 ? void 0 : _f.map(exports.reverseMapDegreePlanTerm),
    });
};
exports.reverseMapDegreePlan = reverseMapDegreePlan;
// Snap-specific term DTO: new cohort plans have no server-assigned degreePlanTermId yet,
// and courses should not carry a failed flag on initial creation.
// Matches Angular's serializeDegreePlan term format exactly.
const snapDegreePlanTermDto = (t) => ({
    degreePlanTerm: {
        termId: t.term.id,
        position: t.position,
    },
    degreePlanTermCourseDtos: t.courses.map(c => ({
        degreePlanTermCourse: { courseId: c.course.id },
    })),
});
const buildSnapPayload = (opts) => ({
    studentIds: opts.studentIds,
    cohortDto: {
        cohort: {
            tenantId: opts.tenantId,
            organizationId: opts.organizationId,
            academicProgramId: opts.academicProgramId,
            program: opts.program,
            specialization: opts.specialization,
            track: opts.track,
        },
    },
    degreePlanDto: {
        degreePlan: {
            type: 'cohort',
            tenantId: opts.tenantId,
            organizationId: opts.organizationId,
            academicProgramId: opts.academicProgramId,
            graduationDate: opts.graduationDate,
        },
        degreePlanTermDtos: opts.terms.map(snapDegreePlanTermDto),
    },
});
exports.buildSnapPayload = buildSnapPayload;
/* eslint-enable @typescript-eslint/no-explicit-any */
